/** Canonical omnibar colors by entity/resource type — shared by quick actions, nav search, and result rows */
export const OMNIBAR_ENTITY_COLORS = {
	product: '#ec4899',
	store: '#0ea5e9',
	cabinet: '#0284c7',
	transaction: '#10b981',
	promotion: '#22c55e',
	restock: '#0ea5e9',
	marketing: '#6366f1',
	pricing: '#8b5cf6',
	finance: '#f97316',
	analytics: '#2563eb',
	settings: '#64748b',
	help: '#06b6d4',
	learn: '#06b6d4',
	bug: '#ef4444',
	feature: '#f59e0b',
	navigate: '#64748b',
} as const

export type OmnibarEntityColorKey = keyof typeof OMNIBAR_ENTITY_COLORS

export function getOmnibarEntityColor(entity: string): string {
	if (entity in OMNIBAR_ENTITY_COLORS) {
		return OMNIBAR_ENTITY_COLORS[entity as OmnibarEntityColorKey]
	}
	return OMNIBAR_ENTITY_COLORS.settings
}
